import Base from "./base";
import apiDispatcher from "@/utils/api-dispatcher";
import {
  CLUB_TEAM_HIGHLIGHT_INDEX,
  CLUB_TEAM_HIGHLIGHT_SHOW,
  CLUB_TEAM_HIGHLIGHT_UPDATE,
  CLUB_TEAM_HIGHLIGHT_CREATE,
  CLUB_TEAM_HIGHLIGHT_DELETE,
  CLUB_TEAM_HIGHLIGHT_IMAGE
} from "@/utils/api-url";

export default class ClubTeamHighlight extends Base {
  constructor(params = {}) {
    super(params);
    this.id = params["_id"] || this.id || "";
    this.title = params["title"] || this.title || "";
    this.image = params["image"] || this.image || "";
    this.description = params["description"] || this.description || "";
    this.updatedAt = params["updatedAt"] || this.updatedAt || "";
    this.video1 = params["video1"] || this.video1 || "";
    this.video2 = params["video2"] || this.video2 || "";
    this.videoDesc1 = params["videoDesc1"] || this.videoDesc1 || "";
    this.videoDesc2 = params["videoDesc2"] || this.videoDesc2 || "";
  }

  static resourceName() {
    return "ClubTeamHighlight";
  }

  static index(params) {
    const profileId = this.profileId();
    return apiDispatcher(CLUB_TEAM_HIGHLIGHT_INDEX(params, profileId));
  }

  static indexLimited(params) {
    const profileId = this.profileId();
    return apiDispatcher(
      CLUB_TEAM_HIGHLIGHT_INDEX({ ...params, limit: 3, page: 1 }, profileId)
    );
  }

  static showWithProfileId(params) {
    const profileId = this.profileId();
    return apiDispatcher(CLUB_TEAM_HIGHLIGHT_SHOW(params, profileId));
  }

  static update(params) {
    const profileId = localStorage["profile-id"];
    return apiDispatcher(CLUB_TEAM_HIGHLIGHT_UPDATE(params, profileId));
  }

  static create(params) {
    const profileId = localStorage["profile-id"];
    return apiDispatcher(CLUB_TEAM_HIGHLIGHT_CREATE(params, profileId));
  }

  static delete(params) {
    const profileId = localStorage["profile-id"];
    return apiDispatcher(CLUB_TEAM_HIGHLIGHT_DELETE(params, profileId));
  }

  static imageUpdate(params) {
    const profileId = localStorage["profile-id"];
    return apiDispatcher(CLUB_TEAM_HIGHLIGHT_IMAGE(params.image, params.id));
  }
}
